<template>
  <v-dialog
    v-model="visibility"
    max-width="500"
    persistent
  >
    <v-card>
      <div class="px-0">

        <v-card-title class="headline pl-4 py-2 pr-2">
          Google Drive
          <v-spacer></v-spacer>
          <v-btn
            @click.native="visibility = false"
            icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>
        <div>
          <div
            ref="scrollContainer"
            class="scrollable-height">
            <v-alert
              v-model="error"
              class="ma-0"
              dismissible
              type="error"
            >
              {{errorMsg}}
            </v-alert>
            <div class="py-4">
              <div class="px-4">
                <v-text-field
                  v-model.trim="gdData.gd_client_id"
                  label="Client ID"
                  :error-messages="errors.collect('gd_client_id')"
                  v-validate="'max:100|required'"
                  data-vv-name="gd_client_id"
                  data-vv-as="client ID"
                  clearable
                  required
                ></v-text-field>
              </div>
              <div class="px-4">
                <v-text-field
                  v-model.trim="gdData.gd_client_secret"
                  label="Client Secret"
                  :error-messages="errors.collect('gd_client_secret')"
                  v-validate="'max:30|required'"
                  data-vv-name="gd_client_secret"
                  data-vv-as="client secret"
                  clearable
                  required
                ></v-text-field>
              </div>
              <div class="px-4">
                <v-text-field
                  v-model.trim="gdData.gd_refresh_token"
                  label="Refresh Token"
                  :error-messages="errors.collect('gd_refresh_token')"
                  v-validate="'max:130|required'"
                  data-vv-name="gd_refresh_token"
                  data-vv-as="refresh token"
                  clearable
                  required
                ></v-text-field>
              </div>
              <div class="px-4">
                <v-text-field
                  v-model.trim="gdData.gd_folder_id"
                  label="Folder ID"
                  :error-messages="errors.collect('gd_folder_id')"
                  v-validate="'max:50|required'"
                  data-vv-name="gd_folder_id"
                  data-vv-as="folder ID"
                  clearable
                  required
                ></v-text-field>
              </div>
            </div>
          </div>
          <v-divider></v-divider>
          <v-card-actions class="px-4 py-4">
            <ServerErrors :errorsItems="serverErrors" />

            <v-spacer></v-spacer>

            <v-btn
              color="primary lighten-2"
              flat="flat"
              @click="setVisbility"
            >
              Anuluj
            </v-btn>

            <v-btn
              color="primary"
              :loading="busy"
              :disabled="busy"
              @click="storeGoogleDrive"
            >
              Zapisz
            </v-btn>
          </v-card-actions>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getError } from '../../../helpers/helpers';
import { storeProfile } from '../../../repository/users';
import ServerErrors from '../../common/Errors/ServerErrors.vue';

export default {
  name: 'google-drive-dialog',
  props: ['gdProfileData'],
  components: {
    ServerErrors,
  },
  data: () => ({
    busy: false,
    errorMsg: null,
    error: null,
    serverErrors: [],
    gdData: {
      gd_client_id: null,
      gd_client_secret: null,
      gd_refresh_token: null,
      gd_folder_id: null,
    },
  }),
  computed: {
    ...mapGetters('users', [
      'dialogVisibility',
    ]),
    visibility: {
      get() {
        return this.dialogVisibility.type === 'google-drive';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
  },
  methods: {
    ...mapActions('users', [
      'setDialogVisbility',
    ]),
    ...mapActions('user', [
      'setGdAccess',
    ]),
    setVisbility() {
      this.setDialogVisbility(false);
    },
    clearData() {
      this.$validator.reset();
      this.busy = false;
      this.errorMsg = null;
      this.error = null;
      this.serverErrors = [];
      this.gdData = {
        gd_client_id: null,
        gd_client_secret: null,
        gd_refresh_token: null,
        gd_folder_id: null,
      };
    },
    getServerErrors(errors) {
      const filedKeys = Object.keys(errors);
      filedKeys.forEach((fieldKey) => {
        const fieldErros = errors[fieldKey];
        if (!fieldErros[0] || fieldErros.length <= 0) return;
        fieldErros.forEach((err) => {
          const field = this.$validator.fields.find({
            name: fieldKey,
            scope: this.$options.scope,
          });
          if (field) {
            this.$validator.errors.add({
              id: field.id,
              field: fieldKey,
              msg: err,
              scope: this.$options.scope,
            });
            field.setFlags({
              invalid: true,
              valid: false,
              validated: true,
            });
          } else if (!this.serverErrors.includes(err)) {
            this.serverErrors.push(err);
          }
        });
      });
    },
    getError(errorData) {
      this.dialogBusy = false;
      this.busy = false;
      this.errorMsg = getError(errorData);
      this.error = true;
      this.$refs.scrollContainer.scrollTo(0, 0);
      if (errorData.response.data && errorData.response.data.data) {
        this.getServerErrors(errorData.response.data.data);
      }
    },
    storeGoogleDrive() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.saveGD();
        }
      });
    },
    async saveGD() {
      this.busy = true;
      try {
        await storeProfile(this.gdData);
        this.$emit('refresh-profile');
        this.setGdAccess(true);
        this.setDialogVisbility(false);
        this.busy = false;
      } catch (e) {
        this.getError(e);
      }
    },
  },
  watch: {
    visibility(val, oldVal) {
      if (val) {
        this.gdData = this.gdProfileData;
      }
      if (oldVal) {
        this.clearData();
      }
    },
  },
};
</script>
